import ReferAFriend from "../components/Sections/ReferAFriend";

export default function ReferPage() {
  return (
      <>
          <ReferAFriend />
  
      </>
  ) 
}